import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RmCountPriceListDto } from "./rm-count-pricelist-dto";


export class AllRmCountPriceListResponse extends GlobalResponseObject{
    data?: RmCountPriceListDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: RmCountPriceListDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}